export function formatMoney(value) {
  try {
    const n = typeof value === "string" ? Number(value) : value;
    if (!Number.isFinite(n)) return String(value ?? "");
    return n.toFixed(2);
  } catch {
    return String(value ?? "");
  }
}
